import { FC } from "react";
import Section from "components/gonzo/parts/Section";
import styled from "styled-components";
import Content from "components/gonzo/parts/Content";

const Copyright: FC = () => {
  return (
    <Section>
      <Content>
        <List>
          <Item>©sprite/久奈浜学院FC部</Item>
          <Item>©2006 岡崎 能士・GONZO</Item>
          <Item>©2009 岡崎 能士・GONZO</Item>
          <Item>©2018 友麻碧・Laruha／ＫＡＤＯＫＡＷＡ／「かくりよの宿飯」製作委員会</Item>
          <Item>©2003 佐藤順一・HAL・GONZO／カレイドステージ</Item>
          <Item>©2004 Mahiro Maeda・GONZO／KADOKAWA</Item>
          <Item>©2004 黒澤明／橋本忍／小国英雄／NEP・GONZO</Item>
          <Item>©2007 第501統合戦闘航空団</Item>
          <Item>©2005 Shuzilow．HA・GONZO</Item>
          <Item>©大張正己・赤松和光・GONZO／グラヴィオン製作委員会</Item>
          <Item>©2003 GONZO/爆天計画</Item>
          <Item>©2006 フジテレビジョン／GONZO／ワーナーエンターテイメントジャパン／電通／スカパ－JSAT</Item>
          <Item>©2007鬼頭莫宏・小学館／ゴンゾ</Item>
          <Item>©2003 GONZO／FlyingDog</Item>
          <Item>©2011 GONZO／ファムパートナーズ</Item>
        </List>
      </Content>
    </Section>
  );
};
export default Copyright;

const List = styled.ul`
`;
const Item = styled.li`
  color: #999;
  font-size: 0.8em;
  margin-right: 1em;
  display: inline;
  line-height: 1.62em;
`;
